import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import { KeyRound } from 'lucide-react';
import api from '../lib/api';

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [currentPwd, setCurrentPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrentPwd(''); setNewPwd(''); setConfirmPwd(''); };

  const submit = async () => {
    if (!currentPwd || !newPwd) { toast.error('Fill all fields'); return; }
    if (newPwd.length < 6) { toast.error('New password must be at least 6 characters'); return; }
    if (newPwd !== confirmPwd) { toast.error('New passwords do not match'); return; }
    if (currentPwd === newPwd) { toast.error('New password must be different from the current password'); return; }
    setSaving(true);
    try {
      await api.put('/auth/change-my-password', { current_password: currentPwd, new_password: newPwd });
      toast.success('Password changed successfully');
      reset();
      onOpenChange(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Failed to change password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
      <DialogContent aria-describedby={undefined} className="bg-bg-secondary border border-white/10 max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-serif text-white flex items-center gap-2">
            <KeyRound className="w-4 h-4 text-gold" /> Change Password
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 pt-2">
          <div className="space-y-1">
            <Label className="text-xs uppercase tracking-[0.15em] text-zinc-400 font-sans">Current Password</Label>
            <Input type="password" value={currentPwd} onChange={(e) => setCurrentPwd(e.target.value)} className="bg-transparent border border-white/10 text-white font-sans" data-testid="change-pwd-current" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs uppercase tracking-[0.15em] text-zinc-400 font-sans">New Password</Label>
            <Input type="password" value={newPwd} onChange={(e) => setNewPwd(e.target.value)} className="bg-transparent border border-white/10 text-white font-sans" data-testid="change-pwd-new" />
            <p className="text-[10px] text-zinc-600 font-sans">At least 6 characters</p>
          </div>
          <div className="space-y-1">
            <Label className="text-xs uppercase tracking-[0.15em] text-zinc-400 font-sans">Confirm New Password</Label>
            <Input type="password" value={confirmPwd} onChange={(e) => setConfirmPwd(e.target.value)} className="bg-transparent border border-white/10 text-white font-sans" data-testid="change-pwd-confirm" />
          </div>
          <Button onClick={submit} disabled={saving} className="w-full bg-gold text-black font-bold rounded-sm font-sans h-10" data-testid="change-pwd-submit">
            {saving ? 'Saving...' : 'Change Password'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
